import { Button, Dialog } from "../../ui";
import { useAdminUnsavedChanges } from "../navigation/useAdminUnsavedChanges";

export function UnsavedChangesGuard({
  active,
  description = "입력한 내용은 저장되지 않습니다.",
}: {
  readonly active: boolean;
  readonly description?: string;
}) {
  const blocker = useAdminUnsavedChanges(active);

  return (
    <Dialog
      open={blocker.state === "blocked"}
      title="작성 중인 내용을 버릴까요?"
      description={description}
      onClose={() => blocker.reset?.()}
      secondaryAction={<Button variant="quiet" onClick={() => blocker.reset?.()}>계속 작성</Button>}
      primaryAction={<Button variant="danger" onClick={() => blocker.proceed?.()}>내용 버리기</Button>}
    />
  );
}
